<template>
  <div>
    <v-container :class="$vuetify.breakpoint.mobile ? 'mt-4' : 'mt-8'">
      <h1>
        {{
          $t("whatWillYouCreateToday", {
            name: accountStore.accountFirstName ? ` ${accountStore.accountFirstName}` : "",
          })
        }}
      </h1>
      <p class="text--secondary mb-10">{{ $t("exploreAndStartCreating") }}</p>

      <div v-for="(card, i) in cards" :key="i">
        <div v-if="card.category" class="d-flex align-center mt-8 mb-4">
          <v-icon class="mr-2">{{ card.icon }}</v-icon>
          <h3 v-if="$vuetify.breakpoint.xs">{{ card.category }}</h3>
          <h2 v-else>{{ card.category }}</h2>
        </div>
        <div v-else class="mt-8"></div>
        <div
          class="card-grid"
          :class="{ 'is-blurred-grid': hoveredCard && hoveredCard.startsWith(`${i}-`) && card.tools.length > 1 }"
        >
          <router-link
            v-for="(tool, j) in card.tools"
            :key="`${i}-${j}`"
            class="card"
            :to="tool.href"
            @mouseenter.native="hoveredCard = `${i}-${j}`"
            @mouseleave.native="hoveredCard = null"
          >
            <div class="card__background" :style="`background-image: url(${tool.backgroundImageUrl});`"></div>
            <div class="card__content">
              <p v-if="!$vuetify.breakpoint.xs" class="card__category">{{ tool.category || card.category }}</p>
              <h3 class="card__heading">{{ tool.heading }}</h3>
            </div>
          </router-link>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
import { useAccountStore } from "@/stores/account";
import { useSnackbarStore } from "@/stores/snackbar";
import { useShortStore } from "@/stores/short";

export default {
  name: "ExploreView",
  setup() {
    const accountStore = useAccountStore();
    const shortStore = useShortStore();
    const snackbarStore = useSnackbarStore();
    return { accountStore, shortStore, snackbarStore };
  },
  data() {
    return {
      hoveredCard: null,
    };
  },
  computed: {
    cards() {
      const categories = [];

      if (this.$vuetify.breakpoint.xs)
        categories.push(
          ...[
            {
              category: this.$t("repurpose"),
              icon: "mdi-reload",
              tools: [
                {
                  heading: this.$t("shortClipMaker"),
                  href: "/search",
                  backgroundImageUrl: "/img/gradients/gradient-3.jpeg",
                },
              ],
            },
            {
              category: this.$t("ideate"),
              icon: "mdi-lightbulb-on-outline",
              tools: [
                {
                  category: this.$t("ideate"),
                  heading: this.$t("unlimitedVideoIdeas"),
                  href: "/chat/new?mode=ideas",
                  backgroundImageUrl: "/img/gradients/gradient-24.jpeg",
                },
                // {
                //   category: this.$t("ideate"),
                //   heading: this.$t("youtubeKeywordResearch"),
                //   href: "/keywords",
                //   backgroundImageUrl: "/img/gradients/gradient-6.jpeg",
                // },
              ],
            },
          ]
        );
      else
        categories.push({
          tools: [
            {
              category: this.$t("repurpose"),
              heading: this.$t("shortClipMaker"),
              href: "/search",
              backgroundImageUrl: "/img/gradients/gradient-3.jpeg",
            },
            {
              category: this.$t("ideate"),
              heading: this.$t("unlimitedVideoIdeas"),
              href: "/chat/new?mode=ideas",
              backgroundImageUrl: "/img/gradients/gradient-24.jpeg",
            },
            // {
            //   category: this.$t("ideate"),
            //   heading: this.$t("youtubeKeywordResearch"),
            //   href: "/keywords",
            //   backgroundImageUrl: "/img/gradients/gradient-6.jpeg",
            // },
          ],
        });

      categories.push(...[
        {
          category: this.$t("scripting"),
          icon: "mdi-script-text-outline",
          tools: [
            {
              heading: this.$t("scriptWriter"),
              href: "/chat/new?mode=script&template=general",
              backgroundImageUrl: "/img/gradients/gradient-9.jpeg",
            },
            {
              heading: this.$t("scriptOutline"),
              href: "/chat/new?mode=script&template=outline",
              backgroundImageUrl: "/img/gradients/gradient-10.jpeg",
            },
            {
              heading: this.$t("rewriteScriptOfAnyVideo"),
              href: "/chat/new?mode=rewriteScript",
              backgroundImageUrl: "/img/gradients/gradient-2.jpeg",
            },
          ],
        },
        {
          category: this.$t("uploadAndOptimize"),
          icon: "mdi-lightning-bolt-outline",
          tools: [
            {
              heading: this.$t("videoTitle"),
              href: "/chat/new?mode=title",
              backgroundImageUrl: "/img/gradients/gradient-15.jpeg",
            },
            {
              heading: this.$t("videoDescription"),
              href: "/chat/new?mode=description",
              backgroundImageUrl: "/img/gradients/gradient-17.jpeg",
            },
            {
              heading: this.$t("videoChapters"),
              href: "/chat/new?mode=chapters",
              backgroundImageUrl: "/img/gradients/gradient-19.jpeg",
            },
            {
              heading: this.$t("videoTags"),
              href: "/chat/new?mode=tags",
              backgroundImageUrl: "/img/gradients/gradient-8.jpeg",
            },
            // {
            //   heading: this.$t("videoThumbnail"),
            //   href: "/chat/new?mode=thumbnail",
            //   backgroundImageUrl:
            //     "/img/gradients/gradient-14.jpeg",
            // },
          ],
        },
      ]);

      return categories
    },
  },
};
</script>

<style scoped>
.card-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 24px;
  grid-row-gap: 24px;
  max-width: 1200px;
  width: 100%;
}

@media (min-width: 960px) {
  .card-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (min-width: 1264px) {
  .card-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

.card {
  list-style: none;
  position: relative;
}

.card:before {
  content: "";
  display: block;
  padding-bottom: 100%;
  width: 100%;
}

.card__background {
  background-size: cover;
  background-position: center;
  border-radius: 24px;
  bottom: 0;
  /* filter: brightness(0.75) saturate(1.2) contrast(0.85); */
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  transform-origin: center;
  transform: scale(1) translateZ(0);
  transition: filter 200ms linear, transform 200ms linear;
}

.card:hover .card__background {
  transform: scale(1.05) translateZ(0);
}

.card-grid.is-blurred-grid > .card:not(:hover) .card__background {
  filter: brightness(0.5) saturate(0) contrast(1.2) blur(20px);
}

.card__content {
  left: 0;
  padding: 24px;
  position: absolute;
  top: 0;
}

.card__category {
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.9rem;
  margin-bottom: 8px;
  text-transform: uppercase;
}

.card__heading {
  color: rgba(255, 255, 255, 0.9);
  font-size: 1.35rem;
  text-shadow: 2px 2px 20px rgba(0, 0, 0, 0.2);
  line-height: 1.4;
  font-weight: bold;
}

@media (min-width: 960px) {
  .card__heading {
    font-size: 1.9rem;
  }
}
</style>
